import gql from 'graphql-tag';

export const CONFIRM_APPOINTMENT_BY_LANDLORD = gql`
  mutation LandlordConfirmAppointmentByOps($instructions: String, $appointmentId: Int!) {
    landlordConfirmAppointmentByOps(instructions: $instructions, appointmentId: $appointmentId) {
      id
    }
  }
`;
